var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page article__page"},[(_vm.article.contentHtml)?_c('html-viewer',{staticClass:"page__bd",attrs:{"content":_vm.article.contentHtml}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }